import { render, staticRenderFns } from "./customPageRender.vue?vue&type=template&id=623e427e&scoped=true&lang=pug"
import script from "./customPageRender.vue?vue&type=script&lang=js"
export * from "./customPageRender.vue?vue&type=script&lang=js"
import style0 from "./customPageRender.vue?vue&type=style&index=0&id=623e427e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623e427e",
  null
  
)

export default component.exports